import * as React from 'react';
import ReactResizeDetector from 'react-resize-detector';
import {LinkIcon} from 'src/App/shared/icons/pt-icon-link';
import * as ReactTooltip from 'react-tooltip';
import {localization} from 'src/App/shared/localization/localization';

export interface ILogoEditorPreview {
  showClearProductMotive: boolean;

  onClearProductMotive(): void;

  onVisualizationResize: (width: number, height: number) => void;
}

export class LogoEditorPreview extends React.Component<ILogoEditorPreview> {
  constructor(props: ILogoEditorPreview) {
    super(props);
  }

  public render() {
    return (
      <div className="editor-preview-root">
        <div className="editor-preview-container">
          {/* required!!! - editor inserts names of zones -> TODO remove */}
          <div className="visualization-zone-selector" style={{display: 'none'}}><select id="printing-zone"/></div>
          {/* <!-- zobrazenie vysledku samotna "vizualizacia" --> */}
          <div id="visualization" className="visualization-canvas-container">
            <ReactResizeDetector
              handleHeight={true}
              handleWidth={true}
              onResize={(w, h) => {
                if (w && h) {
                  this.props.onVisualizationResize(w, h)
                }
              }}
            />
          </div>
          {this.props.showClearProductMotive &&
            <div className="product-motive-clear">
              <button
                data-tip={true} data-for='product-motive-clear-tip'
                onClick={() => this.props.onClearProductMotive()}>
                <LinkIcon/>
              </button>
              <ReactTooltip id="product-motive-clear-tip" effect={'solid'} place={'left'} delayShow={200}>
                <div style={{maxWidth: 250}}>{localization.editorLoc.logoEditorContent.toolTips.clearProductMotive}</div>
              </ReactTooltip>
            </div>
          }
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App/logo-app/logo-editor/logo-editor-controls/logo-editor-preview.component.tsx